import * as React from "react";
import { createPortal } from "react-dom";

import Loading from "./Loading";

const GlobalLoading = () => {
  const rootElement = document.getElementById("root");
  return createPortal(
    <div className="fixed top-0 left-0 h-screen w-screen z-9999 overflow-hidden bg-screen">
      <Loading className="!h-screen" />
    </div>,
    rootElement,
  );
};

export default GlobalLoading;
